<template>
  <div class="home">
    <AskForNumber />
    <b-modal
      id="offerModal"
      v-model="modalIsShow"
      :hide-footer="offerBodyLoading"
      modal-class="showDetails"
      size="xl"
      header-close-variant="danger"
      centered
      title=""
    >
      <template #modal-title>
        <div class="d-flex">
          <div class="ml-auto">
            <h2>
              تفاصيل العرض:<span
                v-if="offerBody"
                class="color-primary-dark text-center mb-3 pl-3 pr-3"
              >{{ offerBody["offer_name"] }}</span>
            </h2>
          </div>
        </div>
      </template>
      <div
        v-if="offerBodyLoading"
        class="text-center pt-2 pb-2"
      >
        <b-spinner
          class="color-primary-dark"
          style="width: 7rem; height: 7rem"
        />
      </div>
      <div v-if="!offerBodyLoading && offerBody">
        <img
          :src="offerBody['offer_image_path']"
          style="width: 100%"
        >
        <div v-html="offerBody['offer_body']" />
      </div>

      <!--footer-->
      <template #modal-footer>
        <b-row
          class="w-100"
          style="margin-bottom: 0"
        >
          <b-col
            cols="9"
            sm="4"
            class="order-2 order-sm-1 p-0"
          >
            <div class="d-flex">
              <h4 class="text-secondary ml-3">
                الكميه:
              </h4>
              <div class="quantity d-flex">
                <b-button
                  size="xs"
                  @click="plusQuantity()"
                >
                  <font
                    icon="plus"
                  />
                </b-button>
                <span>{{ quantity }}</span>
                <b-button
                  size="xs"
                  @click="minusQuantity"
                >
                  <font
                    icon="minus"
                  />
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col
            v-if="offerBody"
            cols="3"
            sm="4"
            class="text-center order-1 order-sm-2 d-flex p-0"
          >
            <h4 class="text-secondary">
              <span class="d-none d-sm-inline">السعر:</span>
              <span
                class="color-primary-dark"
              >{{ Math.ceil(selectedOfferPrice) }} دينار
              </span>
            </h4>
          </b-col>

          <b-col
            sm="4"
            class="order-3 mt-2 mt-sm-0 p-0"
          >
            <b-row>
              <b-col cols="8">
                <b-button
                  v-if="!isInCard(selectedOfferId)"
                  variant="default"
                  class="add-to-card w-100"
                  @click="addToShoppingCart()"
                >
                  <span class="shopping-card pl-2 pr-3">
                    <font icon="shopping-cart" />
                  </span>
                  <span>أضف للمشتريات</span>
                </b-button>

                <b-button
                  v-if="isInCard(selectedOfferId)"
                  variant="default"
                  class="remove-from-cart w-100"
                  @click="removeFromCart(selectedOfferId)"
                >
                  <span class="shopping-card pl-2 pr-3">
                    <font icon="trash" />
                  </span>
                  <span>حذف من المشتريات</span>
                </b-button>
              </b-col>
              <b-col cols="4">
                <b-button
                  :href="`https://wa.me/${whatsappNumber}?text=مرحبا, اريد طلب هذا المنتج: ${offerBody['offer_name']}`"
                  variant="default"
                  class="mainColor-btn-outlined text-light mr-auto"
                >
                  <img
                    src="images/whatsapp.svg"
                    width="28"
                  >
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <div class="h-100 w-100">
      <div
        v-if="loading.main"
        class="card-loading text-center"
      >
        <b-spinner
          variant="success"
          style="width: 7rem; height: 7rem"
          label="Spinning"
        />
      </div>
    </div>
    <div v-if="!loading.main">
      <b-container>
        <h1>{{ categoryName }}</h1>

        <b-row>
          <b-col
            v-for="item in items"
            :key="item.id"
            cols="6"
            sm="3"
            class="card-container mb-4"
          >
            <ItemCard
              :in-card="isInCard(item)"
              :item-info="item"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="text-center pt-2 pb-2">
      <b-spinner
        v-if="loading.moreItems"
        class="color-primary-dark"
      />
    </div>
  </div>
</template>
<script>
import ItemCard from "../global/ItemCard";
import AskForNumber from "@/components/global/AskForNumber";
import { mapState, mapMutations, mapActions } from "vuex";
import axios from "axios";
import {getStoreConfig} from "../../config";

const storeConfig = getStoreConfig();

export default {
  name: "Category",
  components: {
    ItemCard,
    AskForNumber,
  },
  data() {
    return {
      whatsappNumber: storeConfig.whatsapp,
      data: [],
      modalIsShow: null,
      items: [],
      pageNumber: 1,
      noMoreItems: false,
      loading: {
        moreItems: false,
        allawoTogetMore: true,
        main: false,
      },
    };
  },
  computed: {
    ...mapState([
      "cart",
      "showPopUp",
      "offerBody",
      "offerBodyLoading",
      "quantity",
      "phone",
      "selectedOfferId",
      "selectedOfferPrice",
    ]),
    categoryName() {
      return this.$route.params.name;
    },
  },
  methods: {
    ...mapMutations(["setShowPopUp", "plusQuantity", "minusQuantity"]),
    ...mapActions(["addToCart", "removeFromCart", "getOfferBody"]),
    async addToShoppingCart() {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        "عند إضافة المنتج للمشتريات سيتم تسجيل الطلب في المتجر وتجهيزه للشحن خلال 24 ساعة",
        {
          okTitle: "متابعة",
          cancelTitle: "إلغاء",
          centered: true,
          title: "تأكيد عملية الشراء",
        }
      );
      if (!confirmed) return;
      let item = {
        name: this.offerBody.offer_name,
        first_offer_price: this.offerBody.initial_price,
        id: this.selectedOfferId,
        image_path: this.offerBody.offer_image_path.split("easysooq.net/")[1],
      };

      await this.addToCart({ item });
      this.modalIsShow = false;
    },
    handleScroll: function () {
      let windowScrollY = window.scrollY;
      let widnowScrollHeight = document.body.scrollHeight;
      let windowHeight = window.innerHeight;

      let scrollFromBottom =
        windowScrollY - (widnowScrollHeight - windowHeight);
      if (scrollFromBottom > -300) {
        if (this.allawoTogetMore && !this.noMoreItems) {
          this.loading.moreItems = true;

          this.getItems(this.pageNumber, this.$route.params.id);
        }
      }
    },
    isInCard(id) {
      if (this.cart) {
        let isItemInCard = this.cart.find((product) => {
          return product.id == id || product.offer_id == id;
        });
        if (isItemInCard) {
          return true;
        } else {
          return false;
        }
      }
    },
    getItems(page, catId) {
      let x = new FormData();
      x.append(
        "action",
        "get_offers_by_items_by_page_size_and_page_number_and_cat_optional"
      );
      x.append("page_size", 8);
      x.append("page_number", page);
      x.append("cat_id", catId);
      this.allawoTogetMore = false;
      axios
        .post(``, x)
        .then((res) => {
          this.pageNumber++;
          this.loading.main = false;
          this.allawoTogetMore = true;
          let respropeties = Object.keys(res.data);
          let dataInArray = [];
          for (let i of respropeties) {
            dataInArray.push(res.data[i]);
          }

          console.log(dataInArray);
          console.log(dataInArray.length);

          this.items = [...this.items, ...dataInArray];
          if (dataInArray.length < 8) {
            this.noMoreItems = true;
          }
          this.loading.moreItems = false;
        })
        .catch(() => {
          this.loading.main = false;
          this.loading.moreItems = false;
        });
    },
  },
  watch: {
    "$route.params.id": function () {
      this.items = [];
      this.loading.main = true;
      this.noMoreItems = false;
      this.getItems(1, this.$route.params.id);
      console.log("changed");
    },
    modalIsShow: function () {
      if (!this.modalIsShow) {
        document.title = "Easy Souq";
        setTimeout(() => {
          this.$router.push({ name: "Category" });
          this.setQuantity(1);
        }, 200);
      }
    },
  },
  mounted() {
    this.getItems(this.pageNumber, this.$route.params.id);
    if (this.$route.query.productId) {
      this.$bvModal.show("offerModal");
      this.getOfferBody(this.$route.query.productId);
    }
  },
  created: function () {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>